var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph",style:('height:' + _vm.height + 'px')},[_c('svg',{ref:"svg",attrs:{"width":_vm.size.width,"height":_vm.size.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }